import { isUsingFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { DimensionEvent, Event, RecommendedData } from './types';
import { configBase } from '@/config/base';
import { Market } from '@shared/config/market/market.models';
import store from '@/store';

// Google Analytics 4 implementation
export const pushDataLayer = (e: Event | DimensionEvent) => {
    if (!configBase.tracking.enabled || isUsingFakeData()) {
        pushDataLayerDebug(e);
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(e);
};

function pushDataLayerDebug(e: Event | DimensionEvent) {
    window.dataLayerDebug = window.dataLayerDebug || [];
    window.dataLayerDebug.push(e);
}

export function getRecommendedData(): RecommendedData {
    const market: Market = store.getters['general/getMarket'];
    const bookingId: string | undefined = store.getters['myBooking/getBookingId'];
    const bookingNumber: string | undefined = store.getters['myBooking/getBookingNumber'];

    return {
        booking_id: bookingId ?? null,
        booking_number: bookingNumber ?? null,
        hostname: market.domain,
        href: window.location.href,
    };
}
